import React from "react";
import AvisoPrivacidadForm from '../AvisoPrivacidad/AvisoPrivacidadForm';

/**
 * Bloque de captura de datos del lead (nombre, correo, WhatsApp) más el CTA
 * de envío. Puramente presentacional: toda la lógica de validación y envío
 * vive en el componente padre (MaterialCalculator).
 */
function LeadCaptureForm({
    leadName,
    setLeadName,
    leadEmail,
    setLeadEmail,
    leadPhone,
    setLeadPhone,
    formError,
    hubspotWarning,
    submitting,
    onSubmit,
}) {
    return (
        <>
            <div className="dc-lead">
                <div className="dc-lead-title">
                    ¡Listo! Déjanos tu nombre y WhatsApp para enviarte tu cotización formal:
                </div>
                <input
                    type="text"
                    value={leadName}
                    onChange={(e) => setLeadName(e.target.value)}
                    placeholder="Tu nombre"
                    autoComplete="name"
                    className="dc-lead-input"
                />
                <input
                    type="email"
                    value={leadEmail}
                    onChange={(e) => setLeadEmail(e.target.value)}
                    placeholder="Tu correo electrónico"
                    autoComplete="email"
                    className="dc-lead-input"
                />
                <input
                    type="tel"
                    inputMode="numeric"
                    value={leadPhone}
                    onChange={(e) => setLeadPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
                    placeholder="Tu WhatsApp a 10 dígitos"
                    autoComplete="tel"
                    maxLength={10}
                    className="dc-lead-input"
                />
                {formError && (
                    <div role="alert" className="dc-lead-error">
                        {formError}
                    </div>
                )}
                {hubspotWarning && (
                    <div role="status" className="dc-lead-error" style={{ opacity: 0.9 }}>
                        {hubspotWarning}
                    </div>
                )}
            </div>

            <button type="button" onClick={onSubmit} disabled={submitting} className="dc-wa-btn">
                {submitting ? (
                    <>
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                            className="dc-spin"
                        >
                            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.3" strokeWidth="3" />
                            <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                        </svg>
                        Procesando...
                    </>
                ) : (
                    <>
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                            <path d="M17.5 14.4c-.3-.1-1.7-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.7 1-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5 0-.1-.6-1.5-.9-2.1-.2-.5-.5-.5-.7-.5H8c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.2 0 1.3.9 2.5 1.1 2.7.1.2 1.9 2.9 4.5 4 .6.3 1.1.4 1.5.5.6.2 1.2.2 1.7.1.5-.1 1.7-.7 1.9-1.3.2-.7.2-1.2.2-1.3-.1-.1-.3-.2-.6-.3zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.3 5L2 22l5.2-1.3c1.4.8 3 1.2 4.8 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3.2.8.8-3.1-.2-.3c-.9-1.4-1.3-3-1.3-4.6 0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2c0 4.5-3.6 8.2-8.2 8.2z" />
                        </svg>
                        Quiero cotizar ahora por WhatsApp
                    </>
                )}
            </button>
            <AvisoPrivacidadForm />
        </>
    );
}

export default LeadCaptureForm;